import { installedThemes } from "@/themes/registry.generated";
import type { ThemeManifest } from "./types";

/** Resolve a theme by id, falling back to the first installed theme. */
export function getTheme(id?: string): ThemeManifest {
  return installedThemes.find((t) => t.id === id) || installedThemes[0];
}

export function listThemes(): { id: string; name: string }[] {
  return installedThemes.map((t) => ({ id: t.id, name: t.name }));
}
